import { SystemIcon } from '@storeblocks/icon';
import { type FC } from 'react';

import { fileExtensionToIconName } from './fileExtensionToIconName';

interface Props {
  fileExtension: string;
}

/**
 * Display a file icon for the specified file extension.
 */
export const FileTypeIcon: FC<Props> = ({ fileExtension }) => {
  const iconName = fileExtensionToIconName(fileExtension);

  return <SystemIcon name={iconName} isPhosphor />;
};
